export default __webpack_public_path__ + "static/media/Banner2022_Bakery-min.a9744104.png";